/* Doutor Cavalo — comportamento das seções dc-* (galeria, kits, compra, barra fixa). */
(() => {
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => [...el.querySelectorAll(s)];

  // Leva para o link externo os parâmetros de campanha da página (utm_source etc.)
  const comUtm = (link) => {
    try {
      const u = new URL(link, location.href);
      new URLSearchParams(location.search).forEach((v, c) => { if (!u.searchParams.has(c)) u.searchParams.set(c, v); });
      return u.toString();
    } catch (e) { return link; }
  };

  class DcGaleria extends HTMLElement {
    connectedCallback() {
      if (this.iniciado) return;
      this.iniciado = true;
      this.trilho = $('[data-trilho]', this);
      if (!this.trilho) return;
      this.cont = $('[data-cont]', this);
      this.mini = $('[data-mini]', this);
      this.slides = [...this.trilho.children];
      if (this.slides.length < 2) {
        $$('.dc-gal-seta', this).forEach((b) => (b.hidden = true));
        if (this.cont) this.cont.hidden = true;
        return;
      }
      if (this.mini) {
        this.slides.forEach((s, i) => {
          const img = s.tagName === 'IMG' ? s : $('img', s);
          const b = document.createElement('button');
          b.type = 'button';
          b.setAttribute('aria-label', 'Foto ' + (i + 1));
          if (img) {
            const t = document.createElement('img');
            t.src = img.currentSrc || img.src;
            t.alt = '';
            t.loading = 'lazy';
            b.appendChild(t);
          } else {
            b.textContent = String(i + 1);
          }
          b.addEventListener('click', () => this.ir(i));
          this.mini.appendChild(b);
        });
      }
      this.trilho.addEventListener('scroll', () => requestAnimationFrame(() => this.marcar()), { passive: true });
      $$('.dc-gal-seta', this).forEach((b) => b.addEventListener('click', () => this.ir(this.indice() + Number(b.dataset.dir))));
      this.trilho.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') this.ir(this.indice() + 1);
        if (e.key === 'ArrowLeft') this.ir(this.indice() - 1);
      });
      this.marcar();
    }
    indice() { return Math.round(this.trilho.scrollLeft / (this.trilho.clientWidth || 1)); }
    ir(i) {
      const alvo = Math.max(0, Math.min(this.slides.length - 1, i));
      this.trilho.scrollTo({ left: this.trilho.clientWidth * alvo, behavior: 'smooth' });
    }
    marcar() {
      const i = this.indice();
      if (this.cont) this.cont.textContent = i + 1 + '/' + this.slides.length;
      if (this.mini) [...this.mini.children].forEach((b, j) => b.setAttribute('aria-current', String(j === i)));
    }
  }

  class DcCompra extends HTMLElement {
    connectedCallback() {
      if (this.iniciado) return;
      this.iniciado = true;
      this.form = document.getElementById(this.dataset.form);
      if (!this.form) return;
      this.secao = this.closest('.dc-produto') || document;
      this.radios = $$('input[name="id"]', this.form);
      this.erro = $('[data-erro]', this.form);
      this.btnCarrinho = $('[data-carrinho]', this.form);
      this.radios.forEach((r) => r.addEventListener('change', () => this.atualizar()));
      this.form.addEventListener('submit', (e) => this.enviar(e));
      if (this.btnCarrinho) this.btnCarrinho.addEventListener('click', (e) => this.adicionar(e));
      this.atualizar();

      this.barra = $('[data-barra]', this);
      this.alvo = $('[data-comprar]', this.form);
      if (this.barra && this.alvo) {
        let pendente = false;
        const checar = () => {
          pendente = false;
          const passou = this.alvo.getBoundingClientRect().bottom < 0;
          this.barra.classList.toggle('on', passou);
          this.barra.setAttribute('aria-hidden', String(!passou));
          this.barra.inert = !passou;
        };
        this.aoRolar = () => { if (!pendente) { pendente = true; requestAnimationFrame(checar); } };
        window.addEventListener('scroll', this.aoRolar, { passive: true });
        window.addEventListener('resize', this.aoRolar);
        checar();
      }
    }
    disconnectedCallback() {
      if (this.aoRolar) {
        window.removeEventListener('scroll', this.aoRolar);
        window.removeEventListener('resize', this.aoRolar);
      }
    }
    selecionado() { return this.radios.find((r) => r.checked) || this.radios.find((r) => !r.disabled) || this.radios[0]; }
    atualizar() {
      const r = this.selecionado();
      if (!r) return;
      this.radios.forEach((x) => {
        const card = x.closest('.dc-kit');
        if (card) card.classList.toggle('dc-sel', x === r);
      });
      $$('[data-resumo]', this.secao).forEach((el) => { el.hidden = el.dataset.resumo !== r.value; });
      const nome = $('[data-barra-nome]', this);
      const preco = $('[data-barra-preco]', this);
      if (nome) nome.textContent = r.dataset.nome || '';
      if (preco) preco.textContent = r.dataset.preco || '';
      this.mostrarErro('');
    }
    enviar(e) {
      const r = this.selecionado();
      if (r && r.dataset.link) {
        e.preventDefault();
        window.location.href = comUtm(r.dataset.link);
      }
    }
    async adicionar(e) {
      e.preventDefault();
      const r = this.selecionado();
      if (!r) return;
      if (r.dataset.link) { window.location.href = comUtm(r.dataset.link); return; }
      const rotas = window.routes || {};
      const carrinho = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      const dados = new FormData(this.form);
      dados.delete('return_to');
      if (carrinho && typeof carrinho.getSectionsToRender === 'function') {
        dados.append('sections', carrinho.getSectionsToRender().map((s) => s.id));
        dados.append('sections_url', window.location.pathname);
        if (typeof carrinho.setActiveElement === 'function') carrinho.setActiveElement(document.activeElement);
      }
      this.btnCarrinho.classList.add('dc-carregando');
      this.mostrarErro('');
      try {
        const resp = await fetch(rotas.cart_add_url || '/cart/add', {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
          body: dados,
        });
        const json = await resp.json();
        if (json.status) {
          this.mostrarErro(json.description || json.message || 'Não foi possível adicionar ao carrinho.');
          return;
        }
        if (!carrinho || typeof carrinho.renderContents !== 'function') {
          window.location.href = rotas.cart_url || '/cart';
          return;
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'dc-produto', productVariantId: r.value, cartData: json });
        }
        carrinho.renderContents(json);
        carrinho.classList.remove('is-empty');
      } catch (err) {
        this.mostrarErro('Não foi possível adicionar ao carrinho. Tente de novo.');
      } finally {
        this.btnCarrinho.classList.remove('dc-carregando');
      }
    }
    mostrarErro(msg) {
      if (!this.erro) return;
      this.erro.textContent = msg;
      this.erro.hidden = !msg;
    }
  }

  // Contador da barra de oferta: conta até a data de fim (horário de Brasília) e some quando ela passa.
  class DcContador extends HTMLElement {
    connectedCallback() {
      if (this.iniciado) return;
      this.iniciado = true;
      const txt = (this.dataset.fim || '').trim();
      const m = txt.match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{1,2}):(\d{2}))?$/);
      if (!m) return;
      this.fim = new Date(`${m[1]}-${m[2]}-${m[3]}T${(m[4] || '23').padStart(2, '0')}:${m[5] || '59'}:00-03:00`).getTime();
      if (Number.isNaN(this.fim)) return;
      this.h = $('[data-h]', this);
      this.m = $('[data-m]', this);
      this.s = $('[data-s]', this);
      this.tick();
      this.timer = setInterval(() => this.tick(), 1000);
    }
    disconnectedCallback() { clearInterval(this.timer); }
    tick() {
      const falta = this.fim - Date.now();
      if (falta <= 0) {
        clearInterval(this.timer);
        this.hidden = true;
        if (this.dataset.esconder === 'true') {
          const barra = this.closest('.dc-oferta');
          if (barra) barra.hidden = true;
        }
        return;
      }
      const z = (n) => String(n).padStart(2, '0');
      const seg = Math.floor(falta / 1000);
      this.h.textContent = z(Math.floor(seg / 3600));
      this.m.textContent = z(Math.floor((seg % 3600) / 60));
      this.s.textContent = z(seg % 60);
      this.hidden = false;
    }
  }

  // Carrossel de cartões no celular: bolinhas que mostram e levam até cada cartão.
  const iniciarCarrossel = (raiz) => {
    if (raiz.dataset.pronto) return;
    raiz.dataset.pronto = '1';
    const trilho = $('[data-trilho-carrossel]', raiz);
    const pontos = $('[data-pontos]', raiz);
    if (!trilho || !pontos) return;
    const itens = () => [...trilho.children];
    const montar = () => {
      pontos.innerHTML = '';
      const rola = trilho.scrollWidth > trilho.clientWidth + 4;
      pontos.hidden = !rola;
      if (!rola) return;
      itens().forEach((item, i) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.tabIndex = -1;
        b.addEventListener('click', () => trilho.scrollTo({ left: item.offsetLeft - trilho.offsetLeft, behavior: 'smooth' }));
        pontos.appendChild(b);
        if (i === 0) b.setAttribute('aria-current', 'true');
      });
    };
    const marcar = () => {
      const lista = itens();
      if (!lista.length) return;
      const passo = lista.length > 1 ? lista[1].offsetLeft - lista[0].offsetLeft : trilho.clientWidth;
      const i = Math.round(trilho.scrollLeft / (passo || 1));
      [...pontos.children].forEach((b, j) => b.setAttribute('aria-current', String(j === i)));
    };
    trilho.addEventListener('scroll', () => requestAnimationFrame(marcar), { passive: true });
    window.addEventListener('resize', () => { montar(); marcar(); });
    montar();
  };

  // Abas (dosagem): clique, setas do teclado e seleção do bloco no editor.
  class DcAbas extends HTMLElement {
    connectedCallback() {
      if (this.iniciado) return;
      this.iniciado = true;
      this.abas = $$('[role="tab"]', this);
      this.abas.forEach((aba, i) => {
        aba.addEventListener('click', () => this.mostrar(i));
        aba.addEventListener('keydown', (e) => {
          const ir = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
          if (!ir) return;
          e.preventDefault();
          const j = (i + ir + this.abas.length) % this.abas.length;
          this.mostrar(j);
          this.abas[j].focus();
        });
      });
    }
    mostrar(i) {
      this.abas.forEach((aba, j) => {
        const sel = i === j;
        aba.setAttribute('aria-selected', String(sel));
        aba.tabIndex = sel ? 0 : -1;
        const painel = document.getElementById(aba.getAttribute('aria-controls'));
        if (painel) painel.hidden = !sel;
      });
    }
  }

  if (!customElements.get('dc-galeria')) customElements.define('dc-galeria', DcGaleria);
  if (!customElements.get('dc-compra')) customElements.define('dc-compra', DcCompra);
  if (!customElements.get('dc-contador')) customElements.define('dc-contador', DcContador);
  if (!customElements.get('dc-abas')) customElements.define('dc-abas', DcAbas);
  const carrosseis = () => $$('[data-carrossel]').forEach(iniciarCarrossel);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', carrosseis); else carrosseis();
  document.addEventListener('shopify:section:load', carrosseis);
  // Editor de temas: ao selecionar uma aba de dosagem, mostra o painel dela.
  document.addEventListener('shopify:block:select', (e) => {
    const aba = e.target && e.target.closest && e.target.closest('[role="tab"]');
    const grupo = aba && aba.closest('dc-abas');
    if (grupo && grupo.mostrar) grupo.mostrar(grupo.abas.indexOf(aba));
  });

  // Editor de temas: ao selecionar uma pergunta, aba ou linha da tabela, abre a sanfona correspondente.
  document.addEventListener('shopify:block:select', (e) => {
    const el = e.target;
    const d = el && (el.tagName === 'DETAILS' ? el : el.closest && el.closest('details'));
    if (d) d.open = true;
  });
})();
